export const excelMimeTypes = [
  'application/vnd.ms-excel',
  'application/msexcel',
  'application/x-msexcel',
  'application/x-ms-excel',
  'application/x-excel',
  'application/x-dos_ms_excel',
  'application/xls',
  'application/x-xls',
  'application/x-cfb',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.oasis.opendocument.spreadsheet',
];

export const pdfMimeTypes = [
  'application/pdf',
  'application/acrobat',
  'application/x-pdf',
  'applications/vnd.pdf',
  'text/pdf',
  'text/x-pdf',
];
export const csvTypes = [
  'text/csv',
  'application/vnd.ms-excel',
  'text/x-csv',
  'application/csv',
  'application/x-csv',
];

export const excludeFromTransfer = [...excelMimeTypes, ...csvTypes];

export const acceptedFilesGDPR = [...excelMimeTypes, ...csvTypes, 'text/plain'];

export const otherMimeTypes = [
  'text/csv',
  'text/comma-separated-values',
  'text/x-comma-separated-values',
  'text/tab-separated-values',
  'text/x-csv',
  'application/csv',
  'application/x-csv',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/epub+zip',
  'application/gzip',
  'image/jpeg',
  'image/png',
  'application/rtf',
  'text/plain',
  'image/webp',
  'application/zip',
  'application/x-7z-compressed',
  'application/x-zip-compressed',
  'image/tiff',
  'image/svg+xml',
  'image/vnd.adobe.photoshop',
  'application/x-adobe-indesign',
  'application/vnd.adobe.indesign-idml-package',
  'application/postscript',
  'font/ttf',
  'font/otf',
  'font/woff',
  'font/woff2',
  'video/x-msvideo',
  'video/mp4',
  'video/mpeg',
  'video/quicktime',
  'video/x-ms-wmv',
  'application/msword',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];

export const allowedMimeTypes = [...excelMimeTypes, ...pdfMimeTypes, ...otherMimeTypes];
